export const modulesConfig = {
  fr: {
    home: {
      gamification: true,
      messages: false,
      speedFormationDueDate: true,
    },
    menu: {
      callbacks: true,
      callbackReminders: true,
      legacyFormLink: false,
      breaks: false,
    },
    additionalSales: {
      leadAssuranceScript: false,
      axaInfoEmail: true,
      carbonOffsetPostsaleMessage: true,
      creditBooster: true,
      retryLockMinutes: 7,
      retryLockMinutesBySaleType: {
        leadAssistance: 4,
        leadCarbonOffset: 4,
        leadMonConseillerPerso: 4,
        leadAxaBillProtection: 4,
        leadProtected: 4,
      },
      retryConfirmation: false,
    },
    zoho: {
      mcp: true,
    },
    customer: {
      siret: true,
      apeCode: true,
      activity: true,
      bacVoucher: true,
      referral: true,
      taxIdCode: false,
      newsletter: true,
      clubSelectra: false,
      secondName: true,
      bornCity: false,
      identity: false,
      birthdateMandatory: false,
      socialReasonMandatory: false,
      blockSaveOnUnsavedClientType: false,
      interactions: false,
      fidelityMaximizer: true,
      salesScript: false,
    },
    address: {
      staircase: false,
      optionalResidenceFields: false,
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: true,
      cadastralFields: false,
      buildingPermit: false,
      lastHolderFields: false,
      consumption: true,
    },
    meter: {
      meterSerialNumber: false,
      secondMeter: false,
      enedisAuth: true,
      grdfAuth: true,
      creatableSupplier: false,
      skipSyntaxCheck: false,
    },
    contract: {
      meterInformation: true,
      meterPower: true,
      tariffOption: true,
      indexElec: true,
      readingDateElec: true,
      prestationPricingModal: true,
      previousProviderElec: false,
      electricityUsage: false,
      voltage: false,
      currentProviderElec: false,
      distributorElec: false,
      originMarketElec: false,
      indexGas: true,
      readingDateGas: true,
      previousProviderGas: false,
      gasUsage: false,
      currentProviderGas: false,
      distributorGas: false,
      originMarketGas: false,
      telecomProviderExternalId: true,
      providerExternalIdMandatory: true,
      telecomPaymentFrequency: true,
      telecomInvoiceSendingMode: true,
      additionalSalesScript: false,
      billingAddressMandatory: false,
      billingAddressSelector: false,
      prefillEnedisData: true,
      useAltPaymentMode: false,
      showMeterWarning: true,
      resetToEnedisValues: true,
      nonCommunicatingMeterCheck: true,
    },
    rightPanel: {
      resources: true,
      ibanVerifier: false,
      distributor: true,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: true,
      showOfferExpirationDate: false,
      showOfferPriceLock: false,
      ignoreProviderIntegration: false,
      manualCarEntry: false,
      requireCityId: false,
    },
    modalSaveAndSend: {
      reviewEmail: true,
      whatsappConsent: false,
      businessCard: true,
      clubSelectra: false,
      newsletter: false,
      recordingScript: false,
    },
  },
  it: {
    home: {
      gamification: false,
      messages: true,
      speedFormationDueDate: true,
    },
    menu: {
      callbacks: false,
      legacyFormLink: false,
      breaks: true,
    },
    additionalSales: {
      leadAssuranceScript: false,
      axaInfoEmail: true,
      carbonOffsetPostsaleMessage: true,
      creditBooster: true,
      retryLockMinutes: 7,
      retryConfirmation: false,
    },
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      companyIdMask: '999 999 999 99',
      apeCode: true,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxIdCode: true,
      newsletter: false,
      clubSelectra: true,
      secondName: false,
      bornCity: true,
      identity: true,
      birthdateMandatory: false,
      socialReasonMandatory: false,
      blockSaveOnUnsavedClientType: false,
      interactions: false,
      fidelityMaximizer: false,
      salesScript: true,
    },
    address: {
      staircase: false,
      optionalResidenceFields: false,
      floor: false,
      apartmentNumber: false,
      province: true,
      isResident: true,
      energyLandscape: false,
      cadastralFields: true,
      buildingPermit: true,
      lastHolderFields: true,
      consumption: false,
    },
    meter: {
      meterSerialNumber: false,
      secondMeter: false,
      enedisAuth: false,
      grdfAuth: false,
      creatableSupplier: false,
      skipSyntaxCheck: false,
    },
    contract: {
      meterInformation: false,
      meterPower: true,
      tariffOption: true,
      indexElec: false,
      readingDateElec: false,
      prestationPricingModal: false,
      previousProviderElec: false,
      electricityUsage: true,
      voltage: true,
      currentProviderElec: true,
      distributorElec: true,
      originMarketElec: true,
      indexGas: false,
      readingDateGas: false,
      previousProviderGas: false,
      gasUsage: true,
      currentProviderGas: true,
      distributorGas: true,
      originMarketGas: true,
      providerExternalIdGas: true,
      telecomProviderExternalId: false,
      providerExternalIdMandatory: false,
      telecomPaymentFrequency: false,
      telecomInvoiceSendingMode: false,
      additionalSalesScript: true,
      billingAddressMandatory: true,
      accountHolderTaxIdCode: true,
      distributorCodeGas: true,
      daysOfUse: true,
      meterCategory: true,
      maxThermalCapacity: true,
      billingAddressSelector: true,
      prefillEnedisData: false,
      useAltPaymentMode: false,
      showMeterWarning: false,
      resetToEnedisValues: false,
      nonCommunicatingMeterCheck: false,
    },
    rightPanel: {
      resources: false,
      ibanVerifier: false,
      distributor: false,
    },
    commonData: {
      comparatorId: 2,
    },
    consumption: {
      showPriceDetails: true,
      showOfferExpirationDate: true,
      showOfferPriceLock: true,
      ignoreProviderIntegration: true,
      manualCarEntry: false,
      requireCityId: true,
    },
    modalSaveAndSend: {
      reviewEmail: false,
      whatsappConsent: false,
      businessCard: false,
      clubSelectra: true,
      newsletter: false,
      recordingScript: true,
    },
  },
  be: {
    home: {
      gamification: false,
      messages: false,
      speedFormationDueDate: true,
    },
    menu: {
      callbacks: false,
      legacyFormLink: true,
      breaks: false,
    },
    additionalSales: {
      leadAssuranceScript: true,
      axaInfoEmail: false,
      carbonOffsetPostsaleMessage: true,
      creditBooster: true,
      retryLockMinutes: 2,
      retryConfirmation: true,
    },
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxIdCode: false,
      newsletter: true,
      clubSelectra: false,
      secondName: true,
      bornCity: false,
      identity: false,
      birthdateMandatory: false,
      socialReasonMandatory: false,
      blockSaveOnUnsavedClientType: false,
      interactions: false,
      fidelityMaximizer: false,
      salesScript: false,
    },
    address: {
      staircase: false,
      optionalResidenceFields: false,
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
      cadastralFields: false,
      buildingPermit: false,
      lastHolderFields: false,
      consumption: true,
    },
    meter: {
      meterSerialNumber: false,
      secondMeter: false,
      enedisAuth: true,
      grdfAuth: false,
      creatableSupplier: false,
      skipSyntaxCheck: true,
    },
    contract: {
      meterInformation: false,
      meterPower: false,
      tariffOption: false,
      indexElec: true,
      readingDateElec: true,
      prestationPricingModal: false,
      previousProviderElec: false,
      electricityUsage: false,
      voltage: false,
      currentProviderElec: false,
      distributorElec: false,
      originMarketElec: false,
      indexGas: true,
      readingDateGas: true,
      previousProviderGas: false,
      gasUsage: false,
      currentProviderGas: false,
      distributorGas: false,
      originMarketGas: false,
      telecomProviderExternalId: true,
      providerExternalIdMandatory: true,
      telecomPaymentFrequency: true,
      telecomInvoiceSendingMode: true,
      additionalSalesScript: false,
      billingAddressMandatory: false,
      billingAddressSelector: false,
      prefillEnedisData: true,
      useAltPaymentMode: false,
      showMeterWarning: false,
      resetToEnedisValues: false,
      nonCommunicatingMeterCheck: false,
    },
    rightPanel: {
      resources: false,
      ibanVerifier: true,
      distributor: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
      showOfferExpirationDate: false,
      showOfferPriceLock: false,
      ignoreProviderIntegration: false,
      manualCarEntry: false,
      requireCityId: false,
    },
    modalSaveAndSend: {
      reviewEmail: true,
      whatsappConsent: false,
      businessCard: true,
      clubSelectra: false,
      newsletter: true,
      recordingScript: false,
    },
  },
  nl: {
    home: {
      gamification: false,
      messages: false,
      speedFormationDueDate: true,
    },
    menu: {
      callbacks: false,
      legacyFormLink: false,
      breaks: false,
    },
    additionalSales: {
      leadAssuranceScript: false,
      axaInfoEmail: true,
      carbonOffsetPostsaleMessage: true,
      creditBooster: true,
      retryLockMinutes: 7,
      retryConfirmation: false,
    },
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxIdCode: false,
      secondName: true,
      bornCity: false,
      identity: false,
      birthdateMandatory: false,
      socialReasonMandatory: false,
      blockSaveOnUnsavedClientType: false,
      interactions: false,
      newsletter: true,
      clubSelectra: false,
      fidelityMaximizer: false,
      salesScript: false,
    },
    address: {
      staircase: false,
      optionalResidenceFields: false,
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
      cadastralFields: false,
      buildingPermit: false,
      lastHolderFields: false,
      consumption: true,
    },
    meter: {
      meterSerialNumber: false,
      secondMeter: false,
      enedisAuth: true,
      grdfAuth: false,
      creatableSupplier: false,
      skipSyntaxCheck: false,
    },
    contract: {
      meterInformation: false,
      meterPower: false,
      tariffOption: false,
      indexElec: true,
      readingDateElec: true,
      prestationPricingModal: false,
      previousProviderElec: false,
      electricityUsage: false,
      voltage: false,
      currentProviderElec: false,
      distributorElec: false,
      originMarketElec: false,
      indexGas: true,
      readingDateGas: true,
      previousProviderGas: false,
      gasUsage: false,
      currentProviderGas: false,
      distributorGas: false,
      originMarketGas: false,
      telecomProviderExternalId: true,
      providerExternalIdMandatory: true,
      telecomPaymentFrequency: true,
      telecomInvoiceSendingMode: true,
      additionalSalesScript: false,
      billingAddressMandatory: false,
      billingAddressSelector: false,
      prefillEnedisData: true,
      useAltPaymentMode: false,
      showMeterWarning: false,
      resetToEnedisValues: false,
      nonCommunicatingMeterCheck: false,
    },
    rightPanel: {
      resources: false,
      ibanVerifier: false,
      distributor: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
      showOfferExpirationDate: false,
      showOfferPriceLock: false,
      ignoreProviderIntegration: false,
      manualCarEntry: false,
      requireCityId: false,
    },
    modalSaveAndSend: {
      reviewEmail: true,
      whatsappConsent: false,
      businessCard: true,
      clubSelectra: false,
      newsletter: false,
      recordingScript: false,
    },
  },
  de: {
    home: {
      gamification: false,
      messages: false,
      speedFormationDueDate: true,
    },
    menu: {
      callbacks: true,
      legacyFormLink: false,
      breaks: false,
    },
    additionalSales: {
      leadAssuranceScript: false,
      axaInfoEmail: false,
      carbonOffsetPostsaleMessage: false,
      creditBooster: false,
      retryLockMinutes: 7,
      retryConfirmation: false,
    },
    zoho: {
      mcp: false,
    },
    customer: {
      siret: false,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: true,
      taxIdCode: false,
      secondName: true,
      bornCity: false,
      identity: false,
      birthdateMandatory: true,
      socialReasonMandatory: true,
      blockSaveOnUnsavedClientType: true,
      interactions: true,
      newsletter: true,
      clubSelectra: false,
      fidelityMaximizer: false,
      salesScript: false,
    },
    address: {
      staircase: false,
      optionalResidenceFields: false,
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
      cadastralFields: false,
      buildingPermit: false,
      lastHolderFields: false,
      consumption: false,
    },
    meter: {
      meterSerialNumber: false,
      secondMeter: false,
      enedisAuth: true,
      grdfAuth: false,
      creatableSupplier: true,
      skipSyntaxCheck: true,
    },
    contract: {
      meterInformation: false,
      meterPower: false,
      tariffOption: false,
      indexElec: false,
      readingDateElec: false,
      prestationPricingModal: false,
      previousProviderElec: true,
      electricityUsage: false,
      voltage: false,
      currentProviderElec: false,
      distributorElec: false,
      originMarketElec: false,
      indexGas: false,
      readingDateGas: false,
      previousProviderGas: true,
      gasUsage: false,
      currentProviderGas: false,
      distributorGas: false,
      originMarketGas: false,
      telecomProviderExternalId: true,
      providerExternalIdMandatory: true,
      telecomPaymentFrequency: true,
      telecomInvoiceSendingMode: true,
      additionalSalesScript: false,
      billingAddressMandatory: false,
      billingAddressSelector: true,
      prefillEnedisData: false,
      useAltPaymentMode: true,
      showMeterWarning: false,
      resetToEnedisValues: false,
      nonCommunicatingMeterCheck: false,
    },
    rightPanel: {
      resources: false,
      ibanVerifier: false,
      distributor: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
      showOfferExpirationDate: false,
      showOfferPriceLock: false,
      ignoreProviderIntegration: false,
      manualCarEntry: true,
      requireCityId: false,
    },
    modalSaveAndSend: {
      reviewEmail: true,
      whatsappConsent: true,
      businessCard: true,
      clubSelectra: false,
      newsletter: false,
      recordingScript: false,
    },
  },
  at: {
    home: {
      gamification: false,
      messages: false,
      speedFormationDueDate: false,
    },
    menu: {
      callbacks: true,
      legacyFormLink: false,
      breaks: false,
    },
    additionalSales: {
      leadAssuranceScript: false,
      axaInfoEmail: false,
      carbonOffsetPostsaleMessage: false,
      creditBooster: false,
      retryLockMinutes: 7,
      retryConfirmation: false,
    },
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      companyIdMask: null,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: true,
      taxIdCode: false,
      secondName: true,
      bornCity: false,
      identity: false,
      birthdateMandatory: true,
      socialReasonMandatory: true,
      blockSaveOnUnsavedClientType: true,
      interactions: true,
      fidelityMaximizer: false,
      salesScript: false,
    },
    address: {
      staircase: true,
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
      newsletter: true,
      clubSelectra: false,
      cadastralFields: false,
      buildingPermit: false,
      lastHolderFields: false,
      consumption: false,
      optionalResidenceFields: true,
    },
    meter: {
      meterSerialNumber: true,
      gridOperator: true,
      secondMeter: true,
      enedisAuth: true,
      grdfAuth: false,
      creatableSupplier: true,
      skipSyntaxCheck: false,
    },
    contract: {
      meterInformation: false,
      meterPower: false,
      tariffOption: false,
      indexElec: false,
      readingDateElec: false,
      prestationPricingModal: false,
      previousProviderElec: true,
      electricityUsage: false,
      voltage: false,
      currentProviderElec: false,
      distributorElec: false,
      originMarketElec: false,
      indexGas: false,
      readingDateGas: false,
      previousProviderGas: true,
      gasUsage: false,
      currentProviderGas: false,
      distributorGas: false,
      originMarketGas: false,
      providerExternalId: true,
      providerExternalIdMandatory: true,
      additionalSalesScript: false,
      billingAddressSelector: true,
      prefillEnedisData: false,
      useAltPaymentMode: true,
      showMeterWarning: false,
      resetToEnedisValues: false,
      nonCommunicatingMeterCheck: false,
    },
    rightPanel: {
      resources: false,
      ibanVerifier: false,
      distributor: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
      showOfferExpirationDate: false,
      showOfferPriceLock: false,
      ignoreProviderIntegration: false,
      manualCarEntry: true,
      requireCityId: false,
    },
    modalSaveAndSend: {
      reviewEmail: true,
      whatsappConsent: true,
      businessCard: true,
      clubSelectra: false,
      newsletter: false,
      recordingScript: false,
    },
  },
}
